import { z } from 'zod';

export const FocusAreaSummaryDisparity = z
  .object({
    focusArea: z.string(),
    metric: z.string(),
    dimension: z.string(),
    demographicReference: z.string(),
    demographicComparison: z.string(),
    referenceLevelCount: z.number().nullable(),
    treatmentLevelCount: z.number().nullable(),
    referenceNumerator: z.number().nullable(),
    treatmentNumerator: z.number().nullable(),
    referenceLevelRateAvg: z.number().nullable(),
    treatmentLevelRateAvg: z.number().nullable(),
    disparity: z.number().nullable(),
    certainty: z.number().nullable(),
    controlledDisparity: z.number().nullable(),
    controlledPvalue: z.number().nullable(),
    debiasDisparity: z.number().nullable(),
    rawDisparity: z.number().nullable(),
  })
  .describe('FocusAreaSummaryDisparity');

export type FocusAreaSummaryDisparity = z.infer<
  typeof FocusAreaSummaryDisparity
>;
